// Defensive JSON-LD renderer.
// Escapes "</script>" sequences so user-supplied content in schema data
// cannot prematurely close the surrounding <script> tag.
// This is best-practice even when all current data is hardcoded.
export function safeJsonLd(schema) {
  return JSON.stringify(schema).replace(/</g, "\\u003c");
}
